/* eslint-disable import/no-anonymous-default-export */
import { MemberShow } from './show/MemberShow';
import { MemberList } from './list/MemberList';
import { MemberEdit } from './edit/MemberEdit';
import { MemberCreate } from './edit/MemberCreate';
import { getFullName } from '@domain/member';
import { MemberSummary } from '@wwf/sdk';

export default {
    list: MemberList,
    show: MemberShow,
    edit: MemberEdit,
    create: MemberCreate,
    recordRepresentation: (record: MemberSummary) => getFullName(record),
};
